import { createElement, registerCustomElement } from "./Utils/CustomElementUtils";

export class DateEditBase extends HTMLFieldSetElement {
    constructor(self?: any) {
        super();
        self ? self._constructor() : this._constructor(); // polyfill
    }

    protected _constructor(): void {
        this.appendChild(createElement({ type: "input", attrs: { "type": "date", "tabindex": "-1" } }));
        this.appendChild(createElement({ type: "input", attrs: { "type": "text" } }));
    }
}

registerCustomElement("tsc-base-dateedit", DateEditBase, "fieldset");
